import React from "react"
import { Col, Row } from "react-bootstrap"
import styles from '../Viewer/Viewer.module.css'
import CustomTooltip from "../../../Elements/Tooltip"
import { handleErrorImage } from "../../../../utis/helper"
import { getTopPage } from "../../../../hooks/utils"

const SessionData = ({ viewDt, thumbs_details }) => {
    const singleSession = viewDt?.sessions?.length === 1 ? viewDt.sessions[0] : null;
    const engagement = singleSession ? singleSession.engagement : viewDt?.engagement;
    const percentViewed = singleSession ? singleSession.percent_viewed : viewDt?.percent_viewed;
    const minViewed = singleSession ? singleSession.min_viewed : viewDt?.min_viewed;

    // Top page: prefer session-level data when only 1 session (avoids receiver_id=NULL gaps)
    let topPagesArray;
    if (singleSession) {
        const topPg = getTopPage(singleSession.time_per_page || [])
            || singleSession.pages?.reduce((max, p) => (!max || (p.seconds || 0) > (max.seconds || 0)) ? p : max, null)?.page;
        topPagesArray = topPg ? [topPg] : [];
    } else {
        topPagesArray = viewDt?.pages_by_time_spent?.pages || [];
    }

    // Exit pages: prefer session-level data when only 1 session
    const exitPages = singleSession
        ? (Array.isArray(singleSession.popular_exit_pages) ? singleSession.popular_exit_pages : [])
        : (viewDt?.popular_exit_pages?.pages?.length > 0
            ? viewDt.popular_exit_pages.pages.map(pg => ({ page: pg }))
            : (Array.isArray(viewDt?.popular_exit_pages) ? viewDt.popular_exit_pages : []));

    return (
        <div className={styles.headerCard}>
            <Row>
                <Col>
                    <div className={styles.stat}>
                        <span className={styles.value}>
                            {engagement?.replace("%", "") || "-"}
                        </span>
                        <div>Score</div>
                    </div>
                </Col>
                <Col>
                    <div className={styles.stat}>
                        <span className={styles.value}>
                            {percentViewed || "-"}
                        </span>
                        <div>Viewed</div>
                    </div>
                </Col>
                <Col>
                    <div className={styles.stat}>
                        <CustomTooltip
                            title={
                                <p className="p-1 text-light">
                                    HH:MM:SS
                                    <br />
                                    Total time may vary by a few seconds
                                </p>
                            }
                        >
                            <span className={styles.value}>
                                {minViewed || "-"}
                            </span>
                        </CustomTooltip>
                        <div>Total Time</div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className={styles.stat}>
                        <span className={styles.value}>
                            {viewDt?.sessions?.length}
                        </span>
                        <div>Visit</div>
                    </div>
                </Col>
                <Col>
                    <div className={styles.stat}>
                        {topPagesArray.map((pg, ind) => (
                            <CustomTooltip
                                key={ind}
                                title={
                                    <div className="bg-whte p-2">
                                        <img
                                            src={`${thumbs_details?.normal}${pg - 1}.${thumbs_details?.extension}`}
                                            onError={(e) => handleErrorImage(e)}
                                            alt={pg}
                                            width="99px"
                                            height="129px"
                                        />
                                    </div>
                                }
                            >
                                <span className={`${styles.value} cursor-help`}>
                                    {pg}
                                </span>
                            </CustomTooltip>
                        ))}
                        <div>Top Page</div>
                    </div>
                </Col>
                <Col>
                    <div className={styles.stat}>
                        {exitPages.map((pg, ind) => (
                            <CustomTooltip
                                key={ind}
                                title={
                                    <div className="bg-whte p-2">
                                        <img
                                            src={`${thumbs_details?.normal}${(pg?.page - 1)}.${thumbs_details?.extension}`}
                                            onError={(e) => handleErrorImage(e)}
                                            alt={pg?.page}
                                            width="99px"
                                            height="129px"
                                        />
                                    </div>
                                }
                            >
                                <span className={`${styles.value} cursor-help`}>
                                    {pg?.page}
                                </span>
                            </CustomTooltip>
                        ))}
                        <div>Exit Page</div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
export default SessionData